export function Pause({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.9875 14.3325V3.6675C7.9875 2.655 7.56 2.25 6.48 2.25H3.7575C2.6775 2.25 2.25 2.655 2.25 3.6675V14.3325C2.25 15.345 2.6775 15.75 3.7575 15.75H6.48C7.56 15.75 7.9875 15.345 7.9875 14.3325Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7492 14.3325V3.6675C15.7492 2.655 15.3217 2.25 14.2417 2.25H11.5192C10.4467 2.25 10.0117 2.655 10.0117 3.6675V14.3325C10.0117 15.345 10.4392 15.75 11.5192 15.75H14.2417C15.3217 15.75 15.7492 15.345 15.7492 14.3325Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
